module.exports = __webpack_public_path__ + "static/media/Monaco.97dcb662.png";